import React, { Component } from 'react';
import maintenanceImg from './assets/maintenance.svg';
import up from './assets/ok-status-icon.svg';
import down from './assets/red-check.svg';

class WhiteBoxHeader extends Component {
  getIndex(services, index) {
    if (index === 0 && services.length > 1) {
      return 'first';
    } else if ((index + 1) === services.length) {
      return 'last';
    } else {
      return '';
    }
  }

  getAlias(service) {
    return (!!service.alias && !!service.alias.length) ? service.alias : service.domain;
  }

  getServices() {
    const services = this.props.services;

    return services.map((service, index) => (
      <div className={'status-row ' + this.getIndex(services, index)} key={service.id}>
        <div className="left">{this.getAlias(service)}</div>
        <div className="right">
          {(service.isUnderMaintenance === 1)
            ? <img src={maintenanceImg} alt="Service is under maintenance" width="24px" /> 
            : ((service.isDown === 0)
              ? <img src={up} alt="Service is up" width="24px"/>
              : <img src={down} alt="Service is down" width="24px"/>)
          }
        </div>
      </div>
    ))
  }

  render() {
    return(
      <div className="whitebox no-padding">
        {this.getServices()}
      </div>
    );
  }
}

export default WhiteBoxHeader;
